const translations = {
  "en": {
    "Agent": "Agent",
    "Close Details": "Close Details",
    "See more": "See more"
  },
  "zh-tw": {
    "Agent": "Agent",
    "Close Details": "收合詳細資料",
    "See more": "查看更多"
  }
};

export default translations;
